<div class="adx-lib-widget-setting-wrapper">
    <div class="adx-settings-dialog">
        <div class="adx-settings-header">
            <h2 class="adx-settings-title">
                {{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.THRUSTER" | translate }} {{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.SETTINGS" | translate }}
            </h2>
            <button mat-icon-button
                    [mat-dialog-close]="true"
                    aria-label="Close Button"
                    class="adx-settings-close-btn">
                <fa-icon [icon]="'xmark'"></fa-icon>
            </button>
        </div>

        <div class="adx-settings-content">
            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.TITLE" | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="widgetTitle">
                </mat-form-field>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ 'OICL_OPENBRIDGE.THRUSTER.WIDGET.WIDGET_HEADER_DISPLAY_OPTIONS' | translate }}</mat-label>
                    <mat-select [(value)]="selectedWidgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
                        @for (option of (openBridgeThrusterWidget.settings.widgetHeader | keyvalue); track option.key) {
                            <mat-option [value]="option.key" [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
                                {{ getText(option.key) | translate }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="adx-form-row adx-toggle-row">
                <mat-slide-toggle class="primary" [(ngModel)]="showWidgetTitle">
                    <span class="adx-toggle-label">{{ 'OICL_OPENBRIDGE.THRUSTER.WIDGET.SHOW_WIDGET_TITLE' | translate }}</span>
                </mat-slide-toggle>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.MMSI" | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="selectedEntityIdPattern">
                </mat-form-field>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.THRUSTER" | translate }} {{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.SELECT" | translate | lowercase }}</mat-label>
                    <mat-select [(ngModel)]="selectedThrusterId">
                        <mat-option>-- {{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.NONE" | translate  }} --</mat-option>
                        @for (thrusterGroup of azimuthThrusterIdNumbers; track thrusterGroup) {
                            <mat-optgroup [label]="getTranslation(thrusterGroup.name)">
                                @for (thrusterIdentityNumber of thrusterGroup.identityNumber; track thrusterIdentityNumber) {
                                    <mat-option [value]="thrusterIdentityNumber.value">{{ thrusterIdentityNumber.viewValue }}</mat-option>
                                }
                            </mat-optgroup>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="adx-settings-footer">
            <button mat-raised-button
                    type="button"
                    [mat-dialog-close]="true">
                {{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.CANCEL" | translate }}
            </button>
            <button mat-raised-button
                    class="primary"
                    type="submit"
                    (click)="onSubmit()">
                {{ "OICL_OPENBRIDGE.THRUSTER.WIDGET.SAVE" | translate }}
            </button>
        </div>
    </div>
</div>
